import React from "react";
import { NOTIFICATION_DOT_SIZE, NOTIFICATION_DOT_VARIANT, NotificationDot } from "src/components/NotificationDot/NotificationDot";
import { getClassnames } from "src/utils/utils";

export const ProfileShorcutNotification = ({ className, show }) => {

  const linkContainer = getClassnames({
    [className]: !!className,
  });

  return (
    <NotificationDot
      show={show}
      variant={NOTIFICATION_DOT_VARIANT.SINGLE}
      size={NOTIFICATION_DOT_SIZE.SMALL}
      className={linkContainer}
    />
  );
};
